export enum EModItemResolutionState {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum EModerationReason {
  Reported = 'REPORTED',
  StrictGroup = 'STRICT_GROUP',
  ModeratedUser = 'MODERATED_USER',
}
